<template>
    <div class="seller-badge-list-card">
        <h3>
            {{ __('Badge Acquired', 'dokan') }}
        </h3>
        <div class="badge_loader" v-if="loading">
            <Bars/>
        </div>
        <div v-else>
            <div class="myGallery" v-if="badges.length">
                <div v-for="(badge, index) in badges" :key="index" class="item">
                    <img
                        @click.prevent="viewBadgeDetails(badge.id)"
                        :src="badge.badge_logo"
                        class="image"
                        :title="decodeHtml( badge.formatted_hover_text )"
                        :alt="badge.badge_name">
                    <strong
                        v-if="badge.event.has_multiple_levels"
                        class="bottom-center"
                        v-tooltip
                        :title="sprintf( __('Level: %d of %d', 'dokan'), badge.acquired_level_count, badge.level_count )">
                        {{ badge.acquired_level_count }}
                    </strong>
                </div>
            </div>
            <div class="no-badge-available" v-if="!badges.length">
                {{ __( 'No badge has been acquired yet.', 'dokan' ) }}
            </div>
        </div>
        <BadgeDetails v-if="badge.id" />
    </div>
</template>

<script>
import BadgeDetails from "../../../components/BadgeDetails.vue";
import Bars from "../../../components/Bars.vue";
import {computed} from "vue";
import mixin from "../../../Mixin.js";
import verificationTypesMixin from "../../../verificationTypesMixin.js";

const apiBase = '/seller-badge/'

export default {
    name: 'SellerBadgeListCard',
    mixins: [mixin, verificationTypesMixin],
    components: {
        Bars,
        BadgeDetails,
    },
    props: {
        vendor_id: {
            type: Number,
            required: true,
        },
        per_page: {
            default: -1,
            type: Number,
            required: false
        },
    },
    data () {
        return {
            loading: false,
            badges: [],
            badge: {
                id: 0,
                vendor_id: this.vendor_id,
                ts: false
            },
        }
    },
    provide() {
        // use function syntax so that we can access `this`
        return {
            getBadgeValue: computed(() => this.badge ),
            getVerificationTypes: computed( () => this.verificationTypes ),
        }
    },
    methods: {
        fetchAllBadges() {
            if ( ! this.vendor_id ) {
                return [];
            }

            this.loading = true;
            let self = this;
            let args = {
                per_page: self.per_page,
                page: 1,
                vendor_id: self.vendor_id,
                badge_status: 'published',
            };

            dokan.api.get(apiBase, args ).done( ( response, status, xhr ) => {
                self.badges = response.filter( (item) => {
                    return item.vendor_count > 0
                } );
            }).always( () => {
                self.loading = false;
            } ).fail( ( jqXHR ) => {
                self.badges = [];
                self.resetCounts();
                let message = dokan_handle_ajax_error( jqXHR );
                if ( message ) {
                    self.showErrorAlert( message );
                }
            } );
        },

        viewBadgeDetails( badge_id ) {
            this.badge.id = badge_id;
            this.badge.ts = Math.random();
        },
    },
    created () {
        this.fetchAllBadges()
    },
}
</script>

<style lang="less" scoped>
.seller-badge-list-card {
    padding: 0 20px 0 20px;
    background-color: #fff;

    .wp-heading-inline {
        margin-bottom: 20px;
    }

    .myGallery {
        position: relative;
        display: grid;
        grid-gap: 15% 10%;
        grid-template-columns: repeat(3, 1fr);
        grid-auto-rows: 1fr;

        .item {
            position: relative;
            img {
                width: 100%;
                cursor: pointer;
            }

            .bottom-center {
                position: absolute;
                width: 17px;
                height: 17px;
                background-color: white;
                border-radius: 50%;
                color: black;
                bottom: 0;
                left: 6px;
                transform: translate(5px, 10px);
                box-shadow: 0px 3.21062px 6.42124px rgb(0 0 0 / 25%);
                text-align: center;
                font-size: 10px;
            }
        }
    }

    .badge_loader {
        position: relative;
    }
}
</style>
